<div class="properties-and-badges" [ngClass] = "{'directHire' : isDirectHire}">
  <shared-signals-indicators [userData]="userData"></shared-signals-indicators>

  <shared-home-staffer-badges *ngIf="userData?.badges?.length" class="hidden-mob" [horizontalOnly]="true"
    [userData]="userData" [isDirectHire] = "isDirectHire">
  </shared-home-staffer-badges>

</div>